import { TableContainer } from "../../../DemandaCriada/styles";
import { CampoAlteracao } from "../../types";

interface BlocoPrincipalProps {
    campos: CampoAlteracao[];
    idPendencia?: number;
}

export default function BlocoPrincipal({ campos, idPendencia }: BlocoPrincipalProps) {
    if (campos.length === 0) {
        return null;
    }

    return (
        <div className="expanded-section">
            <h4 className="section-title">
                Pendência
                {idPendencia && <span style={{ marginLeft: '8px', color: 'var(--c64748b)', fontWeight: 'normal' }}>#{String(idPendencia).padStart(4, '0')}</span>}
            </h4>
            <TableContainer>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th className="field-col-three">Campo</th>
                            <th className="before-col">Antes</th>
                            <th className="after-col">Depois</th>
                        </tr>
                    </thead>
                    <tbody>
                        {campos.map((campo, i) => (
                            <tr key={i} className={i > 0 ? 'border-top' : ''}>
                                <td className="field-cell">{campo.campo}</td>
                                <td className={`before-cell ${campo.antes === '—' ? 'empty-value' : ''}`}>
                                    {campo.antes}
                                </td>
                                <td className={`after-cell ${campo.depois === '—' ? 'empty-value' : ''}`}>
                                    {campo.depois}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </TableContainer>
        </div>
    );
}
